import { render } from "./addInfo_Modal.vue?vue&type=template&id=4c15b1fd"
import script from "./addInfo_Modal.vue?vue&type=script&lang=js"
export * from "./addInfo_Modal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Kumas\\merchandise_record\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__